import request from "@/utils/request";
import baseUrl from "@/utils/base-url";
import axios from "axios";

//随即练习列表
export function randomCon(data) {
    return request({
        url: baseUrl.base + '/random',
        method: "get",
        params: data
    })
}

//精简500题列表
export function getFine(data) {
    return request({
        url: baseUrl.base + '/fine500',
        method: "get",
        params: data
    })
}

//错题列表
export function getError(data) {
    return request({
        url: baseUrl.base + '/errorlist',
        method: "get",
        params: data
    })
}

//知识点列表
export function chapters(data) {
    return request({
        url: baseUrl.base + '/chapters',
        method: "get",
        params: data
    })
}

export function getExamInfo(data) {
    return request({
        url: baseUrl.base + "/exam",
        method: "get",
        params: data
    });
}
export function addExamWrong(data) {
    return request({
        url: baseUrl.base + "/exam/error/add",
        method: "post",
        params: data
    });
}
export function getExamWrong(data) {
    return request({
        url: baseUrl.base + "/exam/errors",
        method: "get",
        params: data
    });
}

export async function comitExam(data, func) {
    // return request({
    //     url: "exam/handin",
    //     method: "post",
    //     params: data
    // });
    // axios.post(baseUrl.base + '/exam/handin', data)
    //     .then((responss)=>{
    //         func(response)
    //     })
    //     .catch((error)=> {
    //         console.log(error);
    //     });
    let res = await axios.post(baseUrl.base + '/exam/handin', data)
    if (res.status === 200) {
        func
    } else {

    }
    console.log('zsaaa', res)
}
